import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { templateCustomFieldsReworkInterface } from 'src/app/util/interfaces/templateCustomFieldsRework';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { LocationSelections } from 'src/app/util/interfaces/locationInterface';
import { SERVICE_TYPES, SERVICE_TYPES_ENUM } from 'src/app/util/interfaces/requestClassification';
import { structBuilder } from 'src/app/util/classes/structBuilder/structBuilder.class';
import { requestInterface } from 'src/app/util/interfaces/request';
@Injectable({
	providedIn: 'root',
})
export class RequestOpeningService {
	private getTemplateUrl = environment.baseApiUrl + 'request/template/{idTemplate}';
	private getTemplateByClassificationUrl = environment.baseApiUrl + 'request/template/classification';
	private getAvailableUsersUrl = environment.baseApiUrl + 'request/relatedEnduser';
	private getAvailableConfidentialUsersUrl = environment.baseApiUrl + 'request/confidentialUser/available';
	private getConfidentialGroupUsersUrl = environment.baseApiUrl + 'request/confidentialGroupUsers';
	private getEnduserDataUrl = environment.baseApiUrl + 'enduser/info';

	private getCustomfieldSearchUrl = environment.baseApiUrl + 'request/customField/search/{idCategory}/{idSolutionArea}';
	private getRelatedKbArchivesUrl = environment.baseApiUrl + 'kb/related?{qryString}';
	private postRequestUrl = environment.baseApiUrl + 'request';
	private postCustomfieldUrl = environment.baseApiUrl + 'request/{idRequest}/customField';
	private getAvailableTemplatesUrl = environment.baseApiUrl + 'request/template';
	private incidentDiscoveryUrl = environment.baseApiUrl + 'request/incident/discovery';

	private getAvailableOptionsUrl = environment.baseApiUrl + 'request/options/available';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getTemplate(idTemplate: string): Observable<templateReworkInterface> {
		const getTemplateUrl = this.getTemplateUrl.replace('{idTemplate}', idTemplate);
		return this.http.get<JSON[]>(getTemplateUrl, { headers: this.headers }).pipe(
			map((templateRes: any) => {
				templateRes = templateRes[0];
				const templateCustomFieldArray: templateCustomFieldsReworkInterface[] = [];
				if (templateRes.fields && templateRes.fields.length > 0) {
					templateRes.fields.forEach((customfieldRes: any) => {
						const newTemplateCustomField: templateCustomFieldsReworkInterface = {
							id: customfieldRes.id,
							field_name: customfieldRes.field_name,
							field_type: customfieldRes.field_type,
							required: customfieldRes.required === true || customfieldRes.required === '1' ? true : false,
							default_value: customfieldRes.default_value,
							hidden_field: customfieldRes.hidden_field,
							items: [],
							values: [],
						};

						customfieldRes.values.forEach((customfieldValueRes: any) => {
							const newValue = {
								name: customfieldValueRes.text_item,
								value: customfieldValueRes.value_item,
								default: customfieldValueRes.default_item,
								related_request_field: customfieldValueRes.related_request_field,
							};

							newTemplateCustomField.items.push(newValue);
						});

						templateCustomFieldArray.push(newTemplateCustomField);
					});
				}

				const templateInterface: templateReworkInterface = {
					id: templateRes.id,
					status: templateRes.status,
					summary: templateRes.summary,
					description: templateRes.description,
					informative: templateRes.informative,
					fields: templateCustomFieldArray,
					id_service_type: templateRes.id_service_type,
					service_type: templateRes.service_type,
					id_scope: templateRes.id_scope,
					scope: templateRes.scope,
					id_category: templateRes.id_category,
					category: templateRes.category,
					id_topic: templateRes.id_topic,
					topic: templateRes.topic,
					id_solution_area: templateRes.id_solution_area,
					solution_area: templateRes.solution_area,
					allowedCiTypes: templateRes.allowedCiTypes,
					mandatoryCiBinding: templateRes.mandatoryCiBinding,
					description_required: templateRes.description_required,
					confidential_request: templateRes.confidential_request,
				};

				return templateInterface;
			})
		);
	}

	getRequestTemplate(solution_area: string, topic: string): Observable<any> {
		return this.http
			.get<any>(this.getTemplateByClassificationUrl, {
				headers: this.headers,
				params: {
					solution_area: solution_area,
					topic: topic,
				},
			})
			.pipe(
				map((res) => {
					return res.data;
				})
			);
	}

	getAvailableUsers(id_customer: string): Observable<enduserInterface[]> {
		return this.http
			.get<JSON[]>(this.getAvailableUsersUrl, { headers: this.headers, params: { id_enduser: '', id_customer: id_customer } })
			.pipe(
				map((endusersRes: any) => {
					const newEnduserArray: enduserInterface[] = [];

					endusersRes.forEach((enduser: any) => {
						const newEnduser: enduserInterface = {
							id: enduser.id,
							fullName: enduser.full_name,
							email: enduser.email,
						};

						newEnduserArray.push(newEnduser);
					});

					return newEnduserArray;
				})
			);
	}

	getAvailableConfidentialUsers(idCustomer?: string): Observable<enduserInterface[]> {
		let getAvailableConfidentialUsersUrl = this.getAvailableConfidentialUsersUrl;
		if (idCustomer) getAvailableConfidentialUsersUrl = getAvailableConfidentialUsersUrl + `?idCustomer=${idCustomer}`;
		return this.http.get<JSON[]>(getAvailableConfidentialUsersUrl, { headers: this.headers }).pipe(
			map((endusersRes: any) => {
				const newEnduserArray: enduserInterface[] = [];

				endusersRes.forEach((enduser: any) => {
					const newEnduser: enduserInterface = {
						id: enduser.id,
						fullName: enduser.full_name,
						email: enduser.email,
					};

					newEnduserArray.push(newEnduser);
				});

				return newEnduserArray;
			})
		);
	}

	getConfidentialGroupUsersByClassification(filters: any): Observable<enduserInterface[]> {
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getConfidentialGroupUsersUrl, { headers: this.headers, params: parameters }).pipe(
			map((endusersRes: any) => {
				const newEnduserArray: enduserInterface[] = [];

				endusersRes.forEach((enduser: any) => {
					const newEnduser: enduserInterface = {
						id: enduser.enduser_id,
						fullName: enduser.full_name,
						email: enduser.email,
					};

					newEnduserArray.push(newEnduser);
				});

				return newEnduserArray;
			})
		);
	}

	getEnduserData(filters: any): Observable<enduserInterface> {
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<enduserInterface>(this.getEnduserDataUrl, { headers: this.headers, params: parameters });
	}

	async getAvailableTemplates(filters: object, targetServiceTypes?: SERVICE_TYPES[]): Promise<templateReworkInterface[]> {
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		if (targetServiceTypes && targetServiceTypes.length > 0)
			parameters = parameters.append(
				'targetServiceTypes',
				targetServiceTypes.map((serviceType) => SERVICE_TYPES_ENUM[serviceType]).join(',')
			);

		const templateRes = (await this.http
			.get(this.getAvailableTemplatesUrl, { headers: this.headers, params: parameters })
			.toPromise()) as any[];

		if (templateRes.length === 0) return [];

		const newTemplateArray: templateReworkInterface[] = [];

		for (const template of templateRes) {
			const newTemplate: templateReworkInterface = {
				id: template.idTemplate,
				summary: template.templateSummary,
				description: template.templateDescription,
				informative: template.informative,
				name: template.templateName,
				fields: [],
				status: '',
				description_required: template.description_required,
				confidential_request: template.confidential_request,
			};
			newTemplateArray.push(newTemplate);
		}

		newTemplateArray.sort((a, b) => {
			if (a.name > b.name) return 1;
			if (a.name < b.name) return -1;
			return 0;
		});

		return newTemplateArray;
	}

	getCustomfieldSearch(idCategory: string, idSolutionArea: string): Observable<templateCustomFieldsReworkInterface[]> {
		const getCustomfieldSearch = this.getCustomfieldSearchUrl
			.replace('{idSolutionArea}', idSolutionArea)
			.replace('{idCategory}', idCategory);
		return this.http.get<any>(getCustomfieldSearch, { headers: this.headers }).pipe(
			map((customfieldRes) => {
				const newCustomfieldArray: templateCustomFieldsReworkInterface[] = [];

				customfieldRes.forEach((customfield: any) => {
					const newCustomfield: templateCustomFieldsReworkInterface = {
						id: customfield.id_request_field,
						field_name: customfield.request_field,
						field_type: customfield.field_type,
						required: customfield.required === true || customfield.required === '1' ? true : false,
						default_value: customfield.default_value,
						hidden_field: customfield.hidden_field,
						items: [],
						values: [],
					};

					customfield.field_values.forEach((values: any) => {
						const customfieldValues = {
							name: values.text_item,
							value: values.value_item,
							default: '0',
							related_request_field: values.related_request_field,
						};

						newCustomfield.items.push(customfieldValues);
					});

					newCustomfieldArray.push(newCustomfield);
				});

				return newCustomfieldArray;
			})
		);
	}

	submitRequest(
		newRequest: requestInterface,
		id_customer: string,
		id_request_template: string,
		id_confidential_users: string[],
		customfieldBody: { requestFields: any[] }
	): Observable<JSON> {
		const body = new structBuilder();
		body.setKey('summary', newRequest.summary);
		body.setKey('description', newRequest.description);
		body.setKey('idEnduser', newRequest.id_enduser);
		body.setKey('location', newRequest.location);
		body.setKey('affected_location', newRequest.affected_location);

		if (newRequest.id_solution_area && newRequest.id_topic && newRequest.id_solution_area !== '' && newRequest.id_topic !== '') {
			body.setKey('idSolutionArea', newRequest.id_solution_area);
			body.setKey('idTopic', newRequest.id_topic);

			if (newRequest.impact !== undefined) {
				body.setKey('impact', newRequest.impact);
			}
			if (newRequest.urgency !== undefined) {
				body.setKey('urgency', newRequest.urgency);
			}
			if (newRequest.severity !== undefined) {
				body.setKey('severity', newRequest.severity);
			}
			if (newRequest.riskType && newRequest.riskType !== '') {
				body.setKey('idRisktype', newRequest.riskType);
			}
		}

		if (newRequest.parent_request.id && newRequest.parent_request.id !== '')
			body.setKey('parent_request', newRequest.parent_request.id);
		body.setKey('emailCC', newRequest.emailCC);
		body.setKey('idCustomer', id_customer);

		if (id_request_template && id_request_template !== '') body.setKey('idTemplate', id_request_template);

		if (newRequest.relatedCis?.length > 0) body.setKey('relatedCis', newRequest.relatedCis.map((ci) => ci.id).join(','));
		if (newRequest.inconsistency?.id && newRequest.inconsistency.id !== '') body.setKey('idInconsistency', newRequest.inconsistency.id);

		body.setKey('confidential', newRequest.confidential === '1' ? '1' : '0');
		if (newRequest.confidential === '1') {
			body.setKey('confidentialUsers', id_confidential_users);
		}

		body.setKey('customFields', customfieldBody);

		return this.http.post<JSON>(this.postRequestUrl, body.struct, { headers: this.headers });
	}

	// submitCustomfield(idRequest : string, customfieldBody : any): Observable<JSON> {
	//   let postCustomfieldUrl = this.postCustomfieldUrl.replace('{idRequest}', idRequest);
	//   return this.http.post<JSON>(postCustomfieldUrl, customfieldBody, {headers: this.headers});
	// }

	getIncidentDiscovery(id_scope: string, id_category: string, id_topic: string, id_group: string, id_cmdb: string[]): Observable<any> {
		return this.http.get(this.incidentDiscoveryUrl, {
			headers: this.headers,
			params: {
				id_scope: id_scope,
				id_category: id_category,
				id_topic: id_topic,
				id_group: id_group,
				id_cmdb: id_cmdb.join(','),
			},
		});
	}

	getAvailableOptions(filters: any): Observable<LocationSelections> {
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<LocationSelections>(this.getAvailableOptionsUrl, { headers: this.headers, params: parameters });
	}
}
